import apiClient from "@/shared/api/apiClient2";

const enc = encodeURIComponent;

function failure(label, e) {
  console.error(`[application/api] ${label}`, e);
  return {
    success: false,
    error: e?.response?.data || e?.message || String(e),
  };
}

// ===== Participant Cabinet (read-only listing для клиента) =====

export const getApplicationList = async (params) => {
  try {
    const { data } = await apiClient.get("/participants-cabinet/applications", {
      params,
    });
    return data;
  } catch (e) {
    return failure("getApplicationList", e);
  }
};

export const getApplicationItem = async (id) => {
  try {
    const { data } = await apiClient.get(
      `/participants-cabinet/applications/${enc(id)}`
    );
    return data;
  } catch (e) {
    return failure("getApplicationItem", e);
  }
};

// ===== Documents (participants-cabinet endpoints) =====

export const getApplicationDocuments = async (id) => {
  try {
    const { data } = await apiClient.get(
      `/participants-cabinet/transactions/${enc(id)}/documents`
    );
    return data;
  } catch (e) {
    return failure("getApplicationDocuments", e);
  }
};

export const uploadApplicationDocument = async (id, formData) => {
  try {
    const { data } = await apiClient.post(
      `/participants-cabinet/transactions/${enc(id)}/documents/upload`,
      formData
    );
    return data;
  } catch (e) {
    return failure("uploadApplicationDocument", e);
  }
};

export const deleteApplicationDocument = async (id, docUuid) => {
  try {
    const { data } = await apiClient.delete(
      `/participants-cabinet/transactions/${enc(id)}/documents/${enc(docUuid)}`
    );
    return data;
  } catch (e) {
    return failure("deleteApplicationDocument", e);
  }
};

export const updateApplicationDocument = async (id, docUuid, payload) => {
  try {
    const { data } = await apiClient.put(
      `/participants-cabinet/transactions/${enc(id)}/documents/${enc(docUuid)}`,
      payload
    );
    return data;
  } catch (e) {
    return failure("updateApplicationDocument", e);
  }
};

// ===== Participants (participants-cabinet endpoints) =====

export const getApplicationParticipants = async (id) => {
  try {
    const { data } = await apiClient.get(
      `/participants-cabinet/transactions/${enc(id)}/participants`
    );
    return data;
  } catch (e) {
    return failure("getApplicationParticipants", e);
  }
};

export const addApplicationParticipant = async (id, payload) => {
  try {
    const { data } = await apiClient.post(
      `/participants-cabinet/transactions/${enc(id)}/participants`,
      payload
    );
    return data;
  } catch (e) {
    return failure("addApplicationParticipant", e);
  }
};

export const updateApplicationParticipant = async (
  id,
  participantUuid,
  payload
) => {
  try {
    const { data } = await apiClient.put(
      `/participants-cabinet/transactions/${enc(id)}/participants/${enc(
        participantUuid
      )}`,
      payload
    );
    return data;
  } catch (e) {
    return failure("updateApplicationParticipant", e);
  }
};

export const deleteApplicationParticipant = async (id, participantUuid) => {
  try {
    const { data } = await apiClient.delete(
      `/participants-cabinet/transactions/${enc(id)}/participants/${enc(
        participantUuid
      )}`
    );
    return data;
  } catch (e) {
    return failure("deleteApplicationParticipant", e);
  }
};

// ===== Application CRUD (admin/notary endpoints, доступны и клиенту) =====

export const getApplicationFullItem = async (tx_id) => {
  try {
    const { data } = await apiClient.get(`/applications/${enc(tx_id)}`);
    return data;
  } catch (e) {
    return failure("getApplicationFullItem", e);
  }
};

export const updateApplication = async (tx_id, payload) => {
  try {
    const { data } = await apiClient.put(
      `/applications/${enc(tx_id)}`,
      payload
    );
    return data;
  } catch (e) {
    return failure("updateApplication", e);
  }
};

export const updateApplicationStatus = async (tx_id, payload) => {
  try {
    const { data } = await apiClient.put(
      `/applications/${enc(tx_id)}/status`,
      payload
    );
    return data;
  } catch (e) {
    return failure("updateApplicationStatus", e);
  }
};

export const updateApplicationNote = async (tx_id, note) => {
  try {
    const { data } = await apiClient.put(`/applications/${enc(tx_id)}/note`, {
      note,
    });
    return data;
  } catch (e) {
    return failure("updateApplicationNote", e);
  }
};

export const updateApplicationDescription = async (tx_id, description) => {
  try {
    const { data } = await apiClient.put(
      `/applications/${enc(tx_id)}/description`,
      { description }
    );
    return data;
  } catch (e) {
    return failure("updateApplicationDescription", e);
  }
};

// ===== Reference (виды исполнительной надписи) =====

export const getExecInscriptionTypes = async () => {
  try {
    const { data } = await apiClient.get(
      "/applications/exec-inscription-types"
    );
    return data;
  } catch (e) {
    return failure("getExecInscriptionTypes", e);
  }
};

// ===== Create / Submit =====

export const createApplicationFromTemplate = async (code, payload) => {
  try {
    const { data } = await apiClient.post(
      `/applications/submit-application-nt/${enc(code)}`,
      payload
    );
    return data;
  } catch (e) {
    return failure("createApplicationFromTemplate", e);
  }
};

export const assignNotaryToApplication = async (tx_id, payload) => {
  try {
    const { data } = await apiClient.put(
      `/applications/${enc(tx_id)}/assign-notary`,
      payload
    );
    return data;
  } catch (e) {
    return failure("assignNotaryToApplication", e);
  }
};

export const createNotaryActionFromApplication = async (tx_id, payload) => {
  try {
    const { data } = await apiClient.post(
      `/applications/${enc(tx_id)}/create-notary-action`,
      payload
    );
    return data;
  } catch (e) {
    return failure("createNotaryActionFromApplication", e);
  }
};
